<div class="l-top-navi">
  <div class="l-wrap l-wrap--sp-tb-full">
    <div class="l-wrap__inner">
      <div class="l-top-navi__inner l-top-navi__inner--has-progress">
        <div class="l-top-navi__heading-area clear-left-margin top-navi-checkin-search">
          <h1
            class="l-top-navi__heading-text top-navi-checkin-search__heading"
            innerHTML="{{ 'm_static_message-heading.onlineCheckIn' | staticMsg }}"
          ></h1>
          <asw-tooltip
            class="top-navi-checkin-search__tooltip"
            iconImage="<img src={{ appConstants.IMG.SUB_HEADER_HELP_WHITE }} alt=&quot;{{
              'alt.helpIcon2' | staticMsg
            }}&quot; width=&quot;20&quot; height=&quot;20&quot;>"
            tooltipContent="{{ 'm_static_message-tooltip.boardingProcedures' | staticMsg }}"
            [tooltipTop]="-85"
          >
          </asw-tooltip>
        </div>
      </div>
    </div>
  </div>
</div>
